// Generated by scripts/generate-web-routes.ts. Page behavior lives in app/.
import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/(portal)/silicon-systems-era/page";
import { parseAtlasSearch } from "@/lib/navigation-target";
import { toPageHead } from "@/lib/page-metadata";
import { loadRoutePage } from "@/lib/page-route";
import { buildRootMetadata } from "@/lib/site-metadata";


export const Route = createFileRoute("/_portal/silicon-systems-era/")({
  loaderDeps: ({ search }) => search,
  loader: ({ params, location }) => loadRoutePage(
    () => import("@/app/(portal)/silicon-systems-era/page"),
    { params, searchParams: parseAtlasSearch(location.searchStr) },
    "/_portal/silicon-systems-era/",
  ),
  head: ({ loaderData }) => toPageHead(loaderData?.metadata ?? {}, {
    parent: buildRootMetadata(),
  }),
  component: PageRoute,

});

function PageRoute() {
  return <Page data={Route.useLoaderData().data} />;
}
